import type { HttpApiError } from '@backmarket/http-api'
import toastTranslations from '@backmarket/nuxt-layer-buyback/utils/Toast.translations'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import type { BuyBackQuotePricingEstimation } from '~/api/quotes/types'

export async function useGetPricingEstimations(
  grades: string[],
  productId: string,
  marketCode: string,
): Promise<BuyBackQuotePricingEstimation[]> {
  const logger = useLogger()
  const i18n = useI18n()
  const { openErrorToast } = useTheToast()
  const $httpFetch = useHttpFetch()

  try {
    return await $httpFetch(
      '/buyback-quotes/api/v1/products/:productId/markets/:marketCode/pricing-estimations',
      {
        method: 'GET',
        pathParams: {
          productId,
          marketCode,
        },
        query: {
          grades,
        },
      },
    )
  } catch (err) {
    openErrorToast({
      title: i18n(toastTranslations.toastErrorTitle),
      content: i18n(toastTranslations.toastErrorContent),
    })

    logger.error('[BUYBACK][API][QUOTES] Error getting pricing estimation', {
      error: err as HttpApiError,
      owners: ['bot-squad-circularity-offer-front'],
    })
  }

  return []
}
